const StVincentAndTheGrenadinesSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112460)">
      <path
        d="M29.5654 2.4318C26.7239 0.881484 23.465 0 20.0002 0C16.5353 0 13.2764 0.881484 10.4349 2.4318L8.6958 20L10.4349 37.5682C13.2764 39.1185 16.5353 40 20.0002 40C23.465 40 26.7239 39.1185 29.5654 37.5682L31.3046 20L29.5654 2.4318Z"
        fill="#FFDA44"
      />
      <path
        d="M10.4348 37.5689V2.43262C4.21789 5.8248 0 12.42 0 20.0009C0 27.5818 4.21789 34.177 10.4348 37.5689Z"
        fill="#338AF3"
      />
      <path
        d="M40.0007 20.0009C40.0007 12.42 35.7828 5.8248 29.5659 2.43262V37.5689C35.7828 34.177 40.0007 27.5818 40.0007 20.0009Z"
        fill="#6DA544"
      />
      <path
        d="M15.6527 25.218L12.1743 20.0006L15.6526 14.7832L19.131 20.0006L15.6527 25.218Z"
        fill="#6DA544"
      />
      <path
        d="M24.3484 25.218L20.8701 20.0006L24.3484 14.7832L27.8267 20.0006L24.3484 25.218Z"
        fill="#6DA544"
      />
      <path
        d="M20.0007 32.175L16.5225 26.9576L20.0007 21.7402L23.479 26.9576L20.0007 32.175Z"
        fill="#6DA544"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112460">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default StVincentAndTheGrenadinesSvg;
